import { utilizationAndCoverageDetailsSelector } from "./utilizationAndCoverageDetailsSelector";
import { RootState } from "../../../../../store";

export const utilizationAndCoverageDetailsLoadingSelector = (
  state: RootState,
): boolean => {
  return !!utilizationAndCoverageDetailsSelector(state)?.isLoading;
};
